import { useCallback, useEffect, useMemo } from 'react';

import { useDrawerStore, usePollsStore } from '@src/stores';
import { useShallow } from 'zustand/react/shallow';
import { useRoomContext } from '@src/contexts';

type TPollView = 'create' | 'view';

const usePollsBox = () => {
  const { polls, setHasUnvisitedPolls } = usePollsStore(
    useShallow((state) => ({ polls: state.polls, setHasUnvisitedPolls: state.setHasUnvisitedPolls }))
  );

  const { canUserCreatePoll } = useRoomContext();

  const { selectedKey, isDrawerOpen, activePollView, setActivePollView } = useDrawerStore(
    useShallow((state) => ({
      selectedKey: state.selectedKey,
      isDrawerOpen: state.isDrawerOpen,
      activePollView: state.activePollView,
      setActivePollView: state.setActivePollView,
    }))
  );

  const pollsLength = useMemo(() => polls.length || 0, [polls.length]);

  const handleChangeView = useCallback((view: TPollView) => {
    view && setActivePollView(view);
  }, []);

  useEffect(() => {
    canUserCreatePoll ? setActivePollView(activePollView) : setActivePollView('view');
  }, [canUserCreatePoll, activePollView]);

  useEffect(() => {
    if (canUserCreatePoll) {
      if (activePollView === 'view') {
        setHasUnvisitedPolls(false);
      }
    } else {
      if (isDrawerOpen && selectedKey === 'polls') {
        setHasUnvisitedPolls(false);
      }
    }
  }, [selectedKey, isDrawerOpen, activePollView, canUserCreatePoll]);

  return {
    pollsLength,
    activePollView,
    canUserCreatePoll,

    handleChangeView,
  };
};

export default usePollsBox;
